import {
  GET_SERVICE_NUMBER_LIST_REQUEST,
  GET_SERVICE_NUMBER_LIST_SUCCESS,
  GET_SERVICE_NUMBER_LIST_FAILURE,
  GET_SERVICE_ELIGIBILITY_DETAILS_SUCCESS,
  GET_SERVICE_ELIGIBILITY_DETAILS_FAILURE,
  GET_SERVICE_ELIGIBILITY_DETAILS_REQUEST,
  GET_STAFF_PLAN_ELIGIBILITY_FAILURE,
  GET_STAFF_PLAN_ELIGIBILITY_REQUEST,
  GET_STAFF_PLAN_ELIGIBILITY_SUCCESS,
  STAFF_PLAN_RECON_ELIGIBILITY_REQUEST,
  STAFF_PLAN_RECON_ELIGIBILITY_SUCCESS,
  STAFF_PLAN_RECON_ELIGIBILITY_FAILURE
} from '@/actions/checkeligibility/actionTypes';

export const initialState = {
  isLoading: false,
  errorNotification: false,
  serviceNumberList: [],
  serviceNumberTotalRecords: 0,
  serviceEligibilityDetails: [],
  staffPlanEligibility: {},
  isLoadingEligibility: false,
  staffPlanError: '',
  isSuccess: false,
  isStaffReconLoading: false,
  staffPlanReconData: {},
  staffPlanReconError: ''
};

const checkEligibilityReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_SERVICE_NUMBER_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_SERVICE_NUMBER_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        serviceNumberList: action.data.serviceNos,
        serviceNumberTotalRecords: action.data.totalRecords
      };
    case GET_SERVICE_NUMBER_LIST_FAILURE:
      return state;
    case GET_SERVICE_ELIGIBILITY_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        errorNotification: false
      };
    case GET_SERVICE_ELIGIBILITY_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorNotification: false,
        serviceEligibilityDetails: action.data
      };
    case GET_SERVICE_ELIGIBILITY_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorNotification: true
      };
    case GET_STAFF_PLAN_ELIGIBILITY_REQUEST:
      return {
        ...state,
        isLoadingEligibility: true,
        staffPlanEligibility: {},
        staffPlanReconData: {},
        staffPlanError: ''
      };
    case GET_STAFF_PLAN_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        isLoadingEligibility: false,
        staffPlanEligibility: action.data,
      };
    case GET_STAFF_PLAN_ELIGIBILITY_FAILURE:
      return {
        ...state,
        isLoadingEligibility: false,
        staffPlanEligibility: {},
        staffPlanError: 'STAFF_ELIGIBILITY_INVALID_EMPLOYEE_ID_ERROR'
      };
    case STAFF_PLAN_RECON_ELIGIBILITY_REQUEST:
      return {
        ...state,
        isStaffReconLoading: true,
        staffPlanReconData: {},
        staffPlanReconError: ''
      };
    case STAFF_PLAN_RECON_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        isStaffReconLoading: false,
        staffPlanReconData: action.data,
      };
    case STAFF_PLAN_RECON_ELIGIBILITY_FAILURE:
      return {
        ...state,
        isStaffReconLoading: false,
        staffPlanReconData: {},
        staffPlanReconError: 'STAFF_ELIGIBILITY_INVALID_EMPLOYEE_ID_ERROR'
      };
  }
  return state;
};
export default checkEligibilityReducers;
